import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import FoundingTeam from './Foundingteam'

const Leadership = () => {
  return (
    <div>
        <SimpleBanner title='Our Leadership' subheading='Home > Company > Leadership' />
        {/* <LeadershipTeam/> */}
        <FoundingTeam/>
    </div>
  )
}

export default Leadership